import React from 'react';
import FaiBox from "../../../../../MuiComponents/FaiBox";
import FaiTypography from "../../../../../MuiComponents/FaiTypography";
import theme from "../../../../../assets/theme";
import {Grid} from "@mui/material";
import FaiSelect from "../../../../../MuiComponents/FaiSelect";
import FormField from "../../../../../components/FormField";
import FaiButton from "../../../../../MuiComponents/FaiButton";
import FaiDropzone from "../../../../../MuiComponents/FaiDropzone";

function PlatformIssues(props) {
    const {typography, borders} = theme;


    return (
        <>
            <FaiBox>
                <FaiBox mb={4}>
                    <FaiTypography fontSize={typography.size.lg} fontWeight={500}>
                        Fill the details below to raise the issue related to the platform.
                    </FaiTypography>
                </FaiBox>
            </FaiBox>
            <FaiBox>
                <Grid container spacing={2}>
                    <Grid item md={6} lg={6}>
                        <FaiBox>
                            <Grid container>
                                <Grid item md={12} lg={12}>
                                    <FaiBox mb={1}>
                                        <FaiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                            <FaiTypography
                                                component="label"
                                                variant="caption"
                                                fontWeight="bold"
                                                textTransform="capitalize"
                                            >
                                                Select the issue
                                            </FaiTypography>
                                        </FaiBox>
                                        <FaiSelect
                                            placeholder={"Choose the issue related to the platform"}
                                            name={"brandName"}
                                            options={[
                                                {value: "clothing", label: "Clothing"},
                                                {value: "electronics", label: "Electronics"},
                                                {value: "furniture", label: "Furniture"},
                                                {value: "others", label: "Others"},
                                                {value: "real estate", label: "Real Estate"},
                                            ]}
                                        />
                                    </FaiBox>
                                </Grid>
                                <Grid item md={12} lg={12}>
                                    <FaiBox mb={4}>
                                        <FormField
                                            multiline rows={5}
                                            label={"Description"}
                                            name={"description"}
                                            placeholder={"Enter Description"}

                                        />
                                    </FaiBox>
                                </Grid>
                                <Grid item md={12} lg={12}>

                                    <Grid container spacing={2}>

                                        <Grid item sm={12} md={8} lg={8}>
                                            <FaiButton
                                                color="primary"
                                                variant={"contained"}
                                                fullWidth
                                                xs={{fontWeight: typography.fontWeightMedium}}
                                            >
                                                Submit issue
                                            </FaiButton>
                                        </Grid>
                                        <Grid item sm={12} md={4} lg={4}>
                                            <FaiButton
                                                color="black"
                                                variant={"outlined"}
                                                fullWidth
                                            >
                                                Cancel
                                            </FaiButton>
                                        </Grid>

                                    </Grid>

                                </Grid>
                            </Grid>
                        </FaiBox>
                    </Grid>
                    <Grid item md={6} lg={6}>
                        <FaiBox mb={1}>
                            <FaiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                <FaiBox>
                                    <FaiTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                        textTransform="capitalize"
                                    >
                                        Upload Document
                                    </FaiTypography>
                                </FaiBox>
                            </FaiBox>
                            <FaiDropzone
                                options={{addRemoveLinks: true, uploadMultiple: false, maxFiles: 1}}/>

                        </FaiBox>
                    </Grid>
                </Grid>
            </FaiBox>
        </>
    );
}

export default PlatformIssues;
